import { Text } from "@next-platform/client-common-spicy-ui";
import React, { useEffect, useState } from "react";

import Trans from "@/components/Trans/Trans";
import { IValidationRef } from "@/pages/Voice/CloneVoice/components/CloneVoiceForm";
import VoiceClipPlayer from "@/pages/Voice/CloneVoice/VoiceClipPlayer";

interface IVoiceClipContainerProps {
  deleteClip(name: string): void;
  clips: File[];
}

const VoiceClipsContainer = ({ clips, deleteClip }: IVoiceClipContainerProps, ref: React.ForwardedRef<IValidationRef>) => {
  const [stateIsPlaying, setStateIsPlaying] = useState("");
  useEffect(() => {
    if (!ref || typeof ref === "function" || ref.current === null) return;
    const currentRef = ref.current;
    currentRef.stopCurrentPlayingClip = () => setStateIsPlaying("");
    return () => {
      currentRef.stopCurrentPlayingClip = null;
    };
  }, [ref]);

  if (!clips?.length) return null;
  const handlePlayClick = (name: string) => {
    setStateIsPlaying(name === stateIsPlaying ? "" : name);
  };

  const voicePlayerActions = {
    handleDeleteClick: deleteClip,
    handlePlayClick,
  };

  return (
    <div className="flex flex-col gap-lg py-lg">
      {clips.map((clip: File) => (
        <VoiceClipPlayer ref={ref} key={clip.name} audioFile={clip} {...voicePlayerActions} isPlaying={clip.name === stateIsPlaying} />
      ))}
      <Text className="text-gray-10 text-sm">
        <Trans i18nKey="voice:form.create.upload.bestResultsHint" />
      </Text>
    </div>
  );
};
export default React.forwardRef(VoiceClipsContainer);
